module.exports = __webpack_public_path__ + "static/media/Placaj ceramic klinker Modern Antracit.5eda1430.jpg";